import button from '../button/button'
import spacer from '../spacer/spacer'
import languages from '../languages/languages'

export default function(o){

  var lang = o.store('lang')

  var click = function(url, isLogo){
    if(_.includes(location.pathname, url)){
      if(isLogo){
        return function(){
          history.pushState({}, '', '/')
          o.render(o)
        }  
      } else {
        return false
      }
    } else {
      return function(){
        history.pushState({}, '', url)
        o.render(o)
      }
    }
  }

  var reload = function(){
    o.render(o)
  }

  var antiArchiveLabel = o.util.getTranslation(o, 'antiArchive')
  var archiveLabel = o.util.getTranslation(o, 'archive')
  var storiesLabel = o.util.getTranslation(o, 'stories')
  var infoLabel = o.util.getTranslation(o, 'info')
  var contactLabel = o.util.getTranslation(o, 'contact')
  var loginLabel = o.util.getTranslation(o, 'login')

  var div =
    $('<div>')
    .addClass('menu')
    .css({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      padding: "1rem"
    })
    .append(
      $('<div>')
      .css({
        padding: '0',
      })
      .append([

        button(o, 'open memory box', click('/', true))
        .css({
          marginLeft: '0.5rem',
        }),

        spacer(o),

        button(o, antiArchiveLabel, click('/anti-archive')),
        button(o, archiveLabel, click('/archive')),
        button(o, storiesLabel, click('/stories')),
        button(o, infoLabel, click('/info')),
        button(o, contactLabel, click('/contact')),
        button(o, loginLabel, click('/login')),

        spacer(o),

        languages(o, reload)
        .css({
          marginRight: '0.5rem',
        }),

      ])
    )

  if(!o.isTouch){
    div.mousemove(function(e){
      div.scrollLeft(
        e.pageX / div.width() * (div[0].scrollWidth - div.width()) + 20
      )
    })
  }

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/menuOld/menu.js